import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  en: {
    route: {
      dashboard: 'Dashboard',
      cars: 'Cars',
      submissions: 'Submissions',
      users: 'Users',
      settings: 'Settings',
      createCar: 'Create Car',
      editCar: 'Edit Car'
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      confirm: 'Confirm',
      actions: 'Actions',
      status: 'Status',
      createdAt: 'Created At',
      search: 'Search',
      reset: 'Reset',
      export: 'Export',
      refresh: 'Refresh'
    },
    car: {
      make: 'Make',
      model: 'Model',
      year: 'Year',
      price: 'Price',
      mileage: 'Mileage',
      fuelType: 'Fuel Type',
      transmission: 'Transmission',
      bodyType: 'Body Type',
      location: 'Location',
      featured: 'Featured',
      views: 'Views',
      seller: 'Seller'
    },
    submission: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      carType: 'Car Type',
      budget: 'Budget',
      message: 'Message',
      status: 'Status',
      notes: 'Notes'
    },
    status: {
      active: 'Active',
      sold: 'Sold',
      pending: 'Pending',
      inactive: 'Inactive',
      approved: 'Approved',
      rejected: 'Rejected',
      completed: 'Completed'
    }
  },
  ru: {
    route: {
      dashboard: 'Панель',
      cars: 'Автомобили',
      submissions: 'Заявки',
      users: 'Пользователи',
      settings: 'Настройки',
      createCar: 'Создать автомобиль',
      editCar: 'Редактировать автомобиль'
    },
    common: {
      save: 'Сохранить',
      cancel: 'Отмена',
      delete: 'Удалить',
      edit: 'Редактировать',
      confirm: 'Подтвердить',
      actions: 'Действия',
      status: 'Статус',
      createdAt: 'Дата создания',
      search: 'Поиск',
      reset: 'Сбросить',
      export: 'Экспорт',
      refresh: 'Обновить'
    },
    car: {
      make: 'Марка',
      model: 'Модель',
      year: 'Год',
      price: 'Цена',
      mileage: 'Пробег',
      fuelType: 'Тип топлива',
      transmission: 'Коробка',
      bodyType: 'Тип кузова',
      location: 'Местоположение',
      featured: 'Рекомендуемые',
      views: 'Просмотры',
      seller: 'Продавец'
    },
    submission: {
      name: 'Имя',
      email: 'Эл. почта',
      phone: 'Телефон',
      carType: 'Тип авто',
      budget: 'Бюджет',
      message: 'Сообщение',
      status: 'Статус',
      notes: 'Заметки'
    },
    status: {
      active: 'Активный',
      sold: 'Продан',
      pending: 'Ожидает',
      inactive: 'Неактивный',
      approved: 'Одобрено',
      rejected: 'Отклонено',
      completed: 'Завершено'
    }
  },
  hy: {
    route: {
      dashboard: 'Վահանակ',
      cars: 'Մեքենաներ',
      submissions: 'Հարցումներ',
      users: 'Օգտատերեր',
      settings: 'Կարգավորումներ',
      createCar: 'Ստեղծել մեքենա',
      editCar: 'Խմբագրել մեքենան'
    },
    common: {
      save: 'Պահպանել',
      cancel: 'Չեղարկել',
      delete: 'Ջնջել',
      edit: 'Խմբագրել',
      confirm: 'Հաստատել',
      actions: 'Գործողություններ',
      status: 'Կարգավիճակ',
      createdAt: 'Ստեղծված է',
      search: 'Որոնել',
      reset: 'Ջնջել',
      export: 'Արտահանել',
      refresh: 'Թարմացնել'
    },
    car: {
      make: 'Մակնիշ',
      model: 'Մոդել',
      year: 'Տարի',
      price: 'Գին',
      mileage: 'Վազք',
      fuelType: 'Վառելիք',
      transmission: 'Փոխանցման տուփ',
      bodyType: 'Թափք',
      location: 'Տեղորոշում',
      featured: 'Թողարկված',
      views: 'Դիտումներ',
      seller: 'Վաճառող'
    },
    submission: {
      name: 'Անուն',
      email: 'Էլ. հասցե',
      phone: 'Հեռախոս',
      carType: 'Մեքենայի տեսակ',
      budget: 'Բյուջե',
      message: 'Հաղորդագրություն',
      status: 'Կարգավիճակ',
      notes: 'Նշումներ'
    },
    status: {
      active: 'Ակտիվ',
      sold: 'Վաճառված',
      pending: 'Սպասում',
      inactive: 'Ոչ ակտիվ',
      approved: 'Հաստատված',
      rejected: 'Մերժված',
      completed: 'Ավարտված'
    }
  },
  zh: {
    route: {
      dashboard: '仪表板',
      cars: '汽车',
      submissions: '提交',
      users: '用户',
      settings: '设置',
      createCar: '创建汽车',
      editCar: '编辑汽车'
    },
    common: {
      save: '保存',
      cancel: '取消',
      delete: '删除',
      edit: '编辑',
      confirm: '确认',
      actions: '操作',
      status: '状态',
      createdAt: '创建时间',
      search: '搜索',
      reset: '重置',
      export: '导出',
      refresh: '刷新'
    },
    car: {
      make: '品牌',
      model: '型号',
      year: '年份',
      price: '价格',
      mileage: '里程',
      fuelType: '燃料类型',
      transmission: '变速箱',
      bodyType: '车身类型',
      location: '位置',
      featured: '精选',
      views: '浏览',
      seller: '卖家'
    },
    submission: {
      name: '姓名',
      email: '邮箱',
      phone: '电话',
      carType: '汽车类型',
      budget: '预算',
      message: '留言',
      status: '状态',
      notes: '备注'
    },
    status: {
      active: '活跃',
      sold: '已售',
      pending: '待定',
      inactive: '未激活',
      approved: '已批准',
      rejected: '已拒绝',
      completed: '已完成'
    }
  }
}

export default new VueI18n({
  locale: localStorage.getItem('admin_lang') || 'en',
  fallbackLocale: 'en',
  messages
})
